//@ts-check
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';

import { faciaCodes, getFaciaName } from '../../../config/facias';
import FormDateField from '../components/FormDateField';
import FormSelect from '../components/FormSelect';
import FormTextField from '../components/FormTextField';

const DetailsView = () => {
    const form = useFormikContext();

    const price = form.values.price.amount;

    const priceLabelText = useMemo(() => {
        const defaultText = 'Price';

        if (!price) {
            return defaultText;
        }

        try {
            let priceNum = price;
            if (typeof priceNum !== 'number') {
                priceNum = parseInt(priceNum);
            }

            if (isNaN(priceNum)) {
                return defaultText;
            }

            const majorPrice = (priceNum / 100).toLocaleString('en-GB', {
                style: 'currency',
                currency: 'GBP',
            });

            return `Price (${majorPrice})`;
        } catch (e) {
            return defaultText;
        }
    }, [price]);

    return (
        <Grid container spacing={4}>
            <Grid item xs={3}>
                <Grid container spacing={2} direction="column">
                    <Grid item>
                        <FormTextField name="name" label="Name" />
                    </Grid>
                    <Grid item>
                        <FormTextField
                            name="price.amount"
                            label={priceLabelText}
                            defaultHelperText="Minor units, i.e 13000, not 130.00"
                        />
                    </Grid>
                    <Grid item>
                        <FormSelect
                            name="launchType"
                            label="Launch Type"
                            placeholder="Select Launch Type"
                            options={[
                                { value: 'date', label: 'Full Date' },
                                { value: 'month', label: 'Month' },
                            ]}
                        />
                    </Grid>
                    <Grid item>
                        <FormSelect
                            name="status"
                            label="Status"
                            placeholder="Select Status"
                            options={[
                                { value: 'available', label: 'Available' },
                                { value: 'draft', label: 'Draft' },
                            ]}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={3}>
                <Grid container spacing={2} direction="column">
                    <Grid item>
                        <FormSelect
                            name="faciaCode"
                            label="Facia"
                            placeholder="Select Facia"
                            options={faciaCodes.map(faciaCode => {
                                return {
                                    value: faciaCode,
                                    label: getFaciaName(faciaCode),
                                };
                            })}
                        />
                    </Grid>
                    <Grid item>
                        <FormTextField name="PLU" label="PLU" />
                    </Grid>
                    <Grid item>
                        <FormDateField
                            name="launchDate"
                            label="Launch Date"
                            type={form.values.launchType}
                            fullWidth
                        />
                    </Grid>
                    <Grid item>
                        <FormSelect
                            name="tier"
                            label="Tier"
                            placeholder="Select Tier"
                            options={[
                                { value: '0', label: '0' },
                                { value: '1', label: '1' },
                                { value: '2', label: '2' },
                                { value: '3', label: '3' },
                            ]}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={6}>
                <FormTextField name="description" label="Description" multiline rows={20} />
            </Grid>
        </Grid>
    );
};

export default DetailsView;
